import Popup from '../Repository/Popup';
import {Box,Typography,Button} from '@mui/material';

//DBRS SKUs not found in Palpa - shared by sales/storage order add product and submit. canProceed=false only closes (sales order block for non-admin)
const SKUPalpaCheckPopup=({popupPalpaCheckCallBack,items,message,canProceed,proceedLabel,application})=>{

    const handleProceed=()=>{
        popupPalpaCheckCallBack(true);
    };

    const handleClose=()=>{
        popupPalpaCheckCallBack(false);
    };

    const footerComponent=(
        <Box sx={{display:'flex',justifyContent:'flex-end',gap:1,mt:2}}>
            <Button variant="outlined" onClick={handleClose}>{application.getLocale(canProceed?'ButtonCancel':'ButtonClose')}</Button>
            {canProceed&&<Button variant="contained" color="warning" onClick={handleProceed}>{application.getLocale(proceedLabel||'ButtonConfirm')}</Button>}
        </Box>
    );

    return (
        <Popup
            title={application.getLocale('TitlePalpaCheck')}
            onClose={handleClose}
            popupWidth={{xs:'100%',sm:'55%',md:'45%',lg:'35%'}}
            footerComponent={footerComponent}>
            <Box sx={{px:2,pb:1}}>
                <Typography variant="body2" sx={{mb:2}}>{message}</Typography>
                {(items||[]).map((item)=>(
                    <Typography key={item.sku_id} variant="body2" color="warning.main">
                        {item.sku_name} — EAN {item.ean||'-'}
                    </Typography>
                ))}
            </Box>
        </Popup>
    );
};

export default SKUPalpaCheckPopup;
